import Layout from "@/layouts";
import {i18n} from "@/utils/i18n";

const costTransaction = {
  path: "/costTransactions",
  component: Layout,
  name: "costTransactions",
  redirect: "/costTransactions/index",
  children: [
    {
      path: "/costTransactions/index",
      component: () => import("@/views/costTransaction/index"),
      name: "costTransactions.index",
      meta: { title: i18n.t(`message.payments_for_expenses`) },
    },
  ],
};

export default costTransaction;
